import React from 'react';
import { SearchResultContainer } from './styles/SearchResults-style';
import { Link } from 'react-router-dom';

const SearchResults = (props) => {
    const searchResponseData = props.searchResponseData;

    return (
        <div>
            {searchResponseData.map((item) => (
                <SearchResultContainer key={item._id} style={{ }}>
                    <Link to="/ExpandedSearchResult" state={{item: item}}>
                        <p><strong>Meeting Name:</strong> {item.meetingName}</p>
                        <p><strong>Owner:</strong> {item.owner}</p>
                        <div>
                            <p><strong>Participants:</strong></p>
                            {item.opiniondict.map((participant) => (
                                <div key={participant.name} style={{ marginLeft: '20px' }}>
                                    <p>{participant.name}</p>
                                </div>
                            ))}
                        </div>
                    </Link>
                </SearchResultContainer>
            ))}
        </div>
    );
}

export default SearchResults;
